import { PRODUCT_FRAGMENT } from '@commons/graphql/storefront/product';
import gql from 'graphql-tag';
const COLLECTION_FRAGMENT = gql `
  fragment CollectionFragment on Collection {
    id
    title
    handle
    metafield(namespace: "SB-P", key: "Hidden") {
      value
    }
    image {
      url
      altText
      width
      height
    }
  }
`;
const PAGE_FRAGMENT = gql `
  fragment PageFragment on Page {
    id
    title
    handle
    metafield(namespace: "SB-P", key: "Hidden") {
      value
    }
  }
`;
const ARTICLE_FRAGMENT = gql `
  fragment ArticleFragment on Article {
    id
    title
    handle
    tags
    metafield(namespace: "SB-P", key: "Hidden") {
      value
    }
    blog {
      id
      title
      handle
    }
    image {
      url
      altText
      width
      height
    }
  }
`;
// Query for predictive search results according to the Shopify Storefront API format
export const PREDICTIVE_SEARCH = gql `
  ${PRODUCT_FRAGMENT}
  ${COLLECTION_FRAGMENT}
  ${PAGE_FRAGMENT}
  ${ARTICLE_FRAGMENT}
  query predictiveSearch($query: String!, $types: [PredictiveSearchType!], $limit: Int) {
    predictiveSearch(query: $query, types: $types, limit: $limit, limitScope: EACH) {
      queries {
        text
      }
      collections {
        ...CollectionFragment
      }
      products {
        ...ProductFragment
      }
      pages {
        ...PageFragment
      }
      articles {
        ...ArticleFragment
      }
    }
  }
`;
